import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

export interface ActiveSeason {
  id: string;
  season_key: string;
  title: string;
  theme: string;
  description: string | null;
  starts_at: string;
  ends_at: string;
  pass_max_points: number;
  my_pass_points: number;
  my_rank: number | null;
  my_challenges_won: number;
  total_participants: number;
}

export interface SeasonLeaderRow {
  user_id: string;
  display_name: string | null;
  pass_points: number;
  challenges_won: number;
  rank: number;
  is_self: boolean;
}

export function useActiveSeason() {
  const { user } = useAuth();
  const [season, setSeason] = useState<ActiveSeason | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    supabase.rpc("get_active_challenge_season").then(({ data }) => {
      setSeason(((data) || [])[0] || null);
      setLoading(false);
    });
  }, [user]);

  return { season, loading };
}

export function useSeasonLeaderboard(limit = 25) {
  const { user } = useAuth();
  const [rows, setRows] = useState<SeasonLeaderRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    supabase.rpc("get_season_leaderboard", { p_limit: limit }).then(({ data }) => {
      setRows((data) || []);
      setLoading(false);
    });
  }, [user, limit]);

  return { rows, loading };
}
